import React, { ReactNode } from "react";
import { GiConsoleController } from "react-icons/gi";
import img from "../../images/AVIZEAU-768x394.png";

type NewsItem = {
  id: string;
  image: string;
  title: string;
  description: string;
  date: string;
  uploadUrl?: string;
  slug?: string;
};

type Props = {
  children?: ReactNode;
  news: NewsItem;
};

const HomeCard = ({ news }: Props) => {
  const uploadUrl = process.env.REACT_APP_FILE_UPLOAD || "";

  return (
    <div className="p-5">
      <div className="transition-all duration-300 bg-white shadow-lg w-80 sm:w-96 h-[360px] rounded-xl hover:shadow-xl flex flex-col">
        <div className="flex justify-center mb-4">
          <div className="rounded-t-lg relative w-full h-[200px] shadow-inner bg-gradient-to-br from-blue-100 to-blue-300 overflow-hidden">
               <img
              src={uploadUrl ? `${uploadUrl}/news/${news.image}` : img}
              alt={news.title}
              className="w-full h-full rounded-t-lg"
            />    
          
          </div>
        </div>
        <h2 className="flex-grow p-2 mb-4 text-sm leading-relaxed text-black text-start sm:text-base line-clamp-3">
          {news.title}
        </h2>
        <p className="p-2 mb-4 overflow-hidden text-sm leading-6 break-words whitespace-normal text-neutral-500 text-start sm:text-base text-ellipsis line-clamp-3">
          {news.description.replace(/<[^>]+>/g, "")}
        </p>
        <div className="flex items-center justify-between p-2">
          <a
            href={`/actualités/${news.slug}`}
            className="text-sm font-semibold transition-colors duration-200 text-primary sm:text-base hover:underline"
          >
            Lire plus
          </a>
          <span className="text-sm text-primary sm:text-base">
          {news.date
            ? new Date(news.date).toLocaleDateString("fr-FR", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })
            : "-"} {/* Affiche un tiret si la date est absente */}
        </span>
        </div>
      </div>
    </div>
  );
};

export default HomeCard;
